let singleton: ReturnType<typeof useAgsUser>

export default () => {
  if (singleton && import.meta.client) {
    return singleton
  }
  singleton = useAgsUser()
  return singleton
}

function useAgsUser() {
  const {
    refresh,
    user,
    isLoggedIn,
    customerType,
    status,
    updateUser,
    updatePassword,
    forceRefresh,
  } = useUser({
    immediate: false,
    key: 'useAgsUser',
    lazy: true,
  })

  const fetch = async () => {
    if (import.meta.server) {
      return
    }

    await refresh()
  }

  return {
    user,
    isLoggedIn,
    customerType,
    status,
    refresh: fetch,
    updateUser,
    updatePassword,
    forceRefresh,
    fetch,
  }
}
